import React, { useEffect } from 'react';

export default function TrustPilotReviewCollector(): JSX.Element | null {
  useEffect(() => {
    // Load TrustPilot script if not already loaded
    const trustPilotScriptId = 'trustpilot-widget-script';
    const existingScript = document.getElementById(trustPilotScriptId);

    if (!existingScript) {
      const script = document.createElement('script');
      script.id = trustPilotScriptId;
      script.src =
        '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      script.type = 'text/javascript';

      document.head.appendChild(script);

      return () => {
        const scriptToRemove = document.getElementById(trustPilotScriptId);
        if (scriptToRemove) {
          document.head.removeChild(scriptToRemove);
        }
      };
    }
  }, []);

  return (
    <div className="trustpilot-review-collector-container">
      <div
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id="56278e9abfbbba0bdcd568bc"
        data-businessunit-id="5b38f65a389fc200016d7bcb"
        data-style-height="52px"
        data-style-width="100%"
        data-token="68b8b05d-1700-44f5-a109-d3fd420c635b"
      >
        <a
          href="https://uk.trustpilot.com/review/www.kitkeeper.co.uk"
          target="_blank"
          rel="noreferrer"
        >
          Trustpilot
        </a>
      </div>
    </div>
  );
}
